var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.46,
    height: 19.399,
    viewBox: "0 0 17.46 19.399",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#4d4d4d;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-924.492,471h-1.94v1.94h1.94Zm3.88,0h-1.94v1.94h1.94Zm3.88,0h-1.94v1.94h1.94Zm1.94-6.789h-.97v-1.94h-1.94v1.94h-7.76v-1.94h-1.94v1.94h-.97a1.93,1.93,0,0,0-1.93,1.932v.008l-.01,13.579a1.94,1.94,0,0,0,1.94,1.94h13.58a1.946,1.946,0,0,0,1.94-1.94V466.147a1.946,1.946,0,0,0-1.94-1.94Zm0,15.519h-13.58v-10.67h13.58Z",
    transform: "translate(930.312 -462.267)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon_calendar.f72f309e873fd3080d9a46cf986b8d46.svg";
export { ForwardRef as ReactComponent };